import parentsPsychotherapyQuestionSet from "../faq/parentsPsychotherapy/allQuestions";

export const psychoterapyParents = {
    'meta': {
        'title': 'Konsultacje dla rodziców #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Konsultacje psychoterapeutyczne dla rodziców. Konsultacje przeprowadzane przez doświadczonych psychoterapeutów, pracujących w różnych nurtach psychoterapii.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 190,
            'next': 190
        },
        'bydgoszcz': {
            'first': 'od 200',
            'next': 180
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/terapia-dzieci-i-mlodziezy-konsultacje-dla-rodzicow/',
        'title': 'Konsultacje dla rodziców #cityLocativeIn#',
        'name': 'Konsultacje dla rodziców #cityLocativeIn#',
        'heading': 'Konsultacje dla rodziców #cityLocativeIn#',
        'fullName': 'Konsultacje dla rodziców'
    },
    'image': {
        'url': '/images/services/konsultacje-dla-rodzicow.webp',
        'width': 886,
        'height': 295,
        'alt': 'Konsultacje dla rodziców'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/konsultacje-dla-rodzicow.webp',
            'width': 886,
            'height': 295,
            'alt': 'Konsultacje dla rodziców'
        }
    },
    'faq': parentsPsychotherapyQuestionSet
}